import React from "react";
import { connect } from "react-redux";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";
import { setMonthlyOrders, setAverageOrderValue } from "../../actions";
import WizardStep from "../WizardStep";
import WizardSidebar from "../WizardSidebar";

import "../../css/Orders.scss";

class Orders extends React.Component {
	static propTypes = {
		cookies: instanceOf(Cookies).isRequired
	};

	constructor(props) {
		super(props);

		this.state = {
			title: "Let's talk numbers",
			text: "Help us project the impact your loyalty program will have.",
			inputMaxLimit: 99999,
			inputFocus: false,
			currency: "$"
		};
	}

	componentDidMount = () => {
		try {
			const getCountry = this.props.cookies.get("_dy_df_geo").split(".")[0];
			if (getCountry === "United Kingdom") {
				this.setState({
					currency: "£"
				});
			}
		} catch (error) {}
	};

	handleInput = (fieldName, value) => {
		let inputValue = parseInt(value);

		// eslint-disable-next-line default-case
		switch (fieldName) {
			case "monthlyOrders": {
				this.props.setMonthlyOrders(inputValue);
				break;
			}
			case "aov": {
				this.props.setAverageOrderValue(inputValue);
				break;
			}
		}
	};

	handleInputArrow = (fieldName, direction) => {
		// Increase or decrease values, limit to  1 <= x <= 100
		if (fieldName === "monthlyOrders") {
			if (direction === "up") {
				const newValue = this.props.orders.monthlyOrders + 1;
				if (newValue > 100) {
					return;
				}
				this.handleInput("monthlyOrders", newValue);
			} else {
				const newValue = this.props.orders.monthlyOrders - 1;
				if (newValue < 1) {
					return;
				}
				this.handleInput("monthlyOrders", newValue);
			}
		}
		if (fieldName === "aov") {
			if (direction === "up") {
				const newValue = this.props.orders.averageOrderValue + 1;
				if (newValue > 100) {
					return;
				}
				this.handleInput("aov", newValue);
			} else {
				const newValue = this.props.orders.averageOrderValue - 1;
				if (newValue < 1) {
					return;
				}
				this.handleInput("aov", newValue);
			}
		}
	};

	handleKeyPress = evt => {
		if (
			(evt.which !== 8 &&
				evt.which !== 0 &&
				evt.which !== 43 &&
				evt.which !== 44 &&
				evt.which !== 45 &&
				evt.which !== 46 &&
				evt.which !== 187 &&
				evt.which !== 189 &&
				evt.which !== 190 &&
				evt.which < 48) ||
			evt.which > 57
		) {
			evt.preventDefault();
		}
	};

	formatResult = result => {
		if (!Number.isInteger(result) || result === 0) {
			return "900,000";
		}
		return result.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	};

	render() {
		return (
			<div className="view orders">
				<WizardSidebar
					title="BUILDING LOYALTY IS A COMPREHENSIVE PROCESS"
					text={
						<div>
							<p>
								It’s about more than just repeat purchases. 
							</p>
							<p>
								Using everything from referrals and rewards, to incentivized actions and VIP tiers, robust Loyalty & Referrals programs allow brands to engage customers across many different levels in order to build lasting relationships.
							</p>
						</div>
					}
					image="step-4"
				/>
				<WizardStep
					title={this.state.title}
					text={this.state.text}
					navigateTo="incentives"
					buttonText="Next"
					actionType="Orders"
					disabledButton={
						this.props.orders.monthlyOrders > 0 &&
						this.props.orders.averageOrderValue > 0
							? ""
							: "disabled"
					}>
					<div className="orders-data">
						<div className="orders-input-fields">
							<form>
								<div className="field value-orders">
									<div className="input-field">
										<input
											min="1"
											max={this.state.inputMaxLimit}
											type="number"
											placeholder="1000"
											ref={input => {
												this.nameInput = input;
											}}
											defaultValue={this.props.orders.monthlyOrders || ""}
											onChange={({ target: { value } }) => {
												this.handleInput("monthlyOrders", value);
											}}
											keypress={({ target }) => {
												this.handleKeyPress(target);
											}}
										/>
										<div className="input-handles">
											<div
												className="handle up"
												onClick={({ target: { value } }) => {
													this.handleInputArrow("monthlyOrders", "up");
												}}
											/>
											<div
												className="handle down"
												onClick={({ target: { value } }) => {
													this.handleInputArrow("monthlyOrders", "down");
												}}
											/>
										</div>
									</div>
									<div className="field-name">Monthly Orders</div>
								</div>
								<div className="field value-aov">
									<div className="input-field">
										<input
											min="1"
											max={this.state.inputMaxLimit}
											type="number"
											placeholder={this.state.currency + "75"}
											defaultValue={this.props.orders.averageOrderValue || ""}
											onChange={({ target: { value } }) => {
												this.handleInput("aov", value);
											}}
											keypress={({ target }) => {
												this.handleKeyPress(target);
											}}
										/>
										<div className="input-handles">
											<div
												className="handle up"
												onClick={({ target: { value } }) => {
													this.handleInputArrow("aov", "up");
												}}
											/>
											<div
												className="handle down"
												onClick={({ target: { value } }) => {
													this.handleInputArrow("aov", "down");
												}}
											/>
										</div>
									</div>
									<div className="field-name">Average Order Value</div>
								</div>
							</form>
						</div>
						<div className="orders-results">
							<div className="calculated-result">
								{this.state.currency}
								<span>
									{this.formatResult(
										this.props.orders.monthlyOrders *
											this.props.orders.averageOrderValue *
											12
									)}
								</span>
							</div>
							<div className="result-name">Annual Revenue</div>
						</div>
					</div>
				</WizardStep>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		orders: state.orders
	};
};

export default withCookies(
	connect(
		mapStateToProps,
		{ setMonthlyOrders, setAverageOrderValue }
	)(Orders)
);
